// TICKET-8 🟡 Fichier sans aucun test (50 lignes, hashing + palette + initials)
// À créer : brand.test.ts — tester getBrandSeed, getBrandInitials, getBrandPalette

import { UserProfile } from '@shared/types';

const BRAND_PALETTES = [
  ['#111111', '#f59e0b'],
  ['#0f172a', '#38bdf8'],
  ['#111827', '#a78bfa'],
  ['#1f2937', '#34d399'],
  ['#0f172a', '#fb7185'],
  ['#111111', '#f97316'],
  ['#172033', '#60a5fa'],
  ['#1f2937', '#facc15'],
];

function hashString(value: string) {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = ((hash << 5) - hash) + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

export function getBrandSeed(profile: Pick<UserProfile, 'company' | 'firstName' | 'lastName'>) {
  const seed = [profile.company, profile.firstName, profile.lastName]
    .map((value) => (value || '').trim())
    .filter(Boolean)
    .join('|');
  return seed || 'Indxone';
}

export function getBrandInitials(profile: Pick<UserProfile, 'company' | 'firstName' | 'lastName'>) {
  const company = (profile.company || '').trim();
  if (company) {
    const parts = company.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0][0] || ''}${parts[1][0] || ''}`.toUpperCase();
    }
    return company.slice(0, 2).toUpperCase();
  }

  const first = (profile.firstName || '').trim();
  const last = (profile.lastName || '').trim();
  const initials = `${first[0] || ''}${last[0] || ''}`.trim();
  return initials ? initials.toUpperCase() : 'IX';
}

export function getBrandPalette(seed: string) {
  const palette = BRAND_PALETTES[hashString(seed) % BRAND_PALETTES.length];
  return {
    background: `linear-gradient(135deg, ${palette[0]}, ${palette[1]})`,
    text: '#ffffff',
    border: 'rgba(255,255,255,0.18)',
  };
}
